import { render } from "./RecordAction.vue?vue&type=template&id=56763399"
import script from "./RecordAction.vue?vue&type=script&lang=js"
export * from "./RecordAction.vue?vue&type=script&lang=js"

import "./RecordAction.vue?vue&type=style&index=0&id=56763399&lang=scss"

import exportComponent from "/app/tmp/origina/V3/v2026.7.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__